// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comment {
  margin-top: 12px;
}
.comment .author-name {
  margin-left: 10px;
  flex: 1;
}
.comment .comment-content {
  margin-top: 10px;
}

.edit-button {
  color: var(--ion-color-primary);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/comment-item/comment-item.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;AACE;EACE,iBAAA;EACA,OAAA;AACJ;AAEE;EACE,gBAAA;AAAJ;;AAIA;EACE,+BAAA;AADF","sourcesContent":[".comment {\n  margin-top: 12px;\n\n  .author-name {\n    margin-left: 10px;\n    flex: 1;\n  }\n\n  .comment-content {\n    margin-top: 10px;\n  }\n}\n\n.edit-button {\n  color: var(--ion-color-primary);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
